__turbopack_context__.v({
  "icon": "HwidMatchModePicker-module___LS7dW__icon",
});
